<template>
  <div class="row no-gutters mainTitle">
    <div class="col-2 colLeft text-center">
      <div v-if="isSwitchEnableActivable" class="expertMode">
        <div class="title">{{ switchEnableName }}</div>
        <!-- <BaseSwitch
          id="enableModeIsActive"
          :modelValue="enableMode"
          :eventClick="true"
          @SwitchClicked="handleSwitchClicked"
        ></BaseSwitch> -->
      </div>
      <div v-else-if="withBackRouter">
        <TrinnovInput
          class="ml-1"
          id="back"
          buttonType="buttonIconText"
          :modelValue="false"
          label="Back"
          :iconBeforeLabel="true"
          :svgPath="require('@/lib/tui/assets/common/arrows/next.svg')"
          :event="true"
          @TrinnovInputChanged="handleTrinnovInputChanged"
        ></TrinnovInput>
      </div>
    </div>
    <div class="col-8 colCenter">
      
      <span class="label">
        {{ label }}
      </span>
      <span v-if="subLabel" class="subLabel">
        {{ subLabel }}
      </span>
    
    </div>
    <div 
      class="col-2 colRight" 
      :class="withFilters ? 'clickable' : null"
      @click="emitFiltersClicked"
    >
      <div 
        v-if="pillLabel && (pillNumber || pillNumber === 0)" 
        class="expertMode" 
        :class="filtersModified ? 'filtersActive' : null"
      >
        <div class="title mr-1">{{ pillLabel }} {{  }}</div>
        {{ pillNumber }}

        <TrinnovInput
          v-if="withFilters"
          buttonType="buttonIcon"
          id="arrow"
          :svgPath="require('@/lib/tui/assets/common/arrows/carret_down.svg')"
          :isActivable="false"
          size="small"
          style="float: right"
          :withBackground="false"
        ></TrinnovInput>
      </div>

      <div v-if="withButton" style="line-height: 0; margin-top: 1vh">
        <TrinnovInput
          buttonType="button"
          id="buttonRight"
          :modelValue="false"
          :label="buttonLabel"
          :event="true"
          @TrinnovInputChanged="handleTrinnovInputChanged"
        ></TrinnovInput>
      </div>
    </div>
  </div>
</template>

<script>
import TrinnovInput from "@/lib/tui/components/buttons/TrinnovInput.vue";
export default {
  name: "CPageTitle",
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  components: {
    TrinnovInput
  },
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  props: {
    label: String,
    subLabel: String,
    isSwitchEnableActivable: { type: Boolean, default: false },
    switchEnableName:{type:String, default: 'Enable'},
    enableModeKey: String,
    isSwitchExpertActivable: { type: Boolean, default: false },
    expertModeKey: String,

    pillLabel: String,
    pillNumber: Number,
    withBackRouter: {
      type: Boolean,
      default: false
    },
    withFilters: {
      type: Boolean,
      default: false
    },
    filtersModified: {
      type: Boolean,
      default: false
    },
    withButton: {
      type: Boolean,
      default: false
    },
    buttonLabel: String
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  // setup(props) {
  //   t_subscribe([
  //   {
  //       property: "enableMode",
  //       path: "/monitoring/control/" + props.enableModeKey,
  //       autoPubreq: false,
  //     },buttonLabel
  //     {
  //       property: "expertMode",
  //       path: "/interface/expert_mode/" + props.expertModeKey,
  //       autoPubreq: false,
  //     }
  //   ]);
  // },
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  data () {
    return {
      expertMode: null,
      enableMode: null
    }
  },
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  methods: {
    handleSwitchClicked: function(event) {
      if (event.id === "enableModeIsActive")
        window.t.pubreq("/monitoring/control", { [this.enableModeKey]: event.value });
      else if (event.id === "expertModeIsActive")
        window.t.pubreq("/interface/expert_mode", { [this.expertModeKey]: event.value });
    },
    /////////////////////////////////////////////////////////////////////////////
    handleTrinnovInputChanged: function(event) {
      if (event.id === "back")
        this.$router.go(-1);
      else
        this.$emit("ButtonRightClicked")
    },
    /////////////////////////////////////////////////////////////////////////////
    emitFiltersClicked: function() {
      if (!this.withFilters) return;

      this.$emit("FiltersClicked");
    }
  }
};
</script>

<style lang="scss" scoped>
  .filtersActive {
    border: 1px solid $active;
  }
</style>
